
export const base_url = 'https://admin.yarlacompany.com/api/';
export const storage_base_url = 'https://admin.yarlacompany.com/storage/';